import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { hideModal } from 'managers/modal'
import { useTranslation } from 'react-i18next'
import { Input } from 'components/ui/Input'
import { useFormik } from 'formik'
import { formFieldProps } from 'utils/form'
import { createValidationSchema, required } from 'utils/validations'
import { UIButton } from 'components/ui/Button'
import { useState } from 'react'
import { resetPassword } from 'api/auth'
import { showSuccessToast } from 'utils/toast'

type ResetPasswordModalProps = {
  email?: string
  onSuccess?: () => void
  backToLogin?: JSX.Element
}

export const ResetPasswordModal = ({ backToLogin, onSuccess, email: initialEmail }: ResetPasswordModalProps) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const { values, errors, setFieldValue, setFieldError, handleSubmit } = useFormik({
    initialValues: {
      email: initialEmail ?? '',
    },
    validationSchema: createValidationSchema({
      email: required,
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      console.debug({ values })
      try {
        setLoading(true)
        await resetPassword(values.email)
        showSuccessToast(t('resetPasswordEmailSend'))
        setLoading(false)
        hideModal()
        onSuccess?.()
      } catch (e) {
        console.error({ e })
        setLoading(false)
      }
    },
  })

  const fieldProps = formFieldProps(errors, values, setFieldError, setFieldValue)

  return (
    <div style={{ padding: 20 }}>
      <div className={'tw-flex tw-flex-row tw-items-center tw-justify-between'}>
        <div className={'tw-font-[800]'}>{t('forgottenPassword')}</div>
        <div className={'tw-cursor-pointer'}>
          <FontAwesomeIcon icon={['far', 'times']} onClick={hideModal} />
        </div>
      </div>
      <div className={'tw-flex tw-flex-col tw-space-y-1 tw-mt-2'}>
        <Input
          label={t('email')}
          {...fieldProps('email')}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSubmit()
            }
          }}
        />
        <div className={'tw-h-3'} />
        <div className={'tw-text-sm'}>{t('resetPasswordHint')}</div>
      </div>
      {backToLogin}
      <div className={'tw-mt-6 tw-w-full'}>
        <UIButton className={'tw-w-full'} onClick={() => handleSubmit()} loading={loading}>
          <span className={'tw-text-sm'}>{t('sendEmailResetPassword')}</span>
        </UIButton>
      </div>
    </div>
  )
}
